/**
 * 정산대장 Excel(CSV) — 세대 이력·월별 세대 내역
 */

import { SETTLEMENT_LABELS } from "./settlementFormat.js";

const C = SETTLEMENT_LABELS.csv;

export const LEDGER_CSV = {
    household: [
        C.regYm,
        C.roomName,
        C.status,
        C.usageQty,
        C.usageShareAmount,
        C.areaShareAmount,
        C.manualAdjustAmount,
        C.totalAmount,
    ],
    matrix: [
        C.regYm,
        C.roomName,
        C.exclusiveArea,
        C.usageQty,
        C.usageShareAmount,
        C.areaShareAmount,
        C.manualAdjustAmount,
        C.totalAmount,
    ],
};

/** 총요금 − 세대 청구 합계 (원 단위 절삭 잔차) */
export function floorRemainder(row) {
    const k = parseFloat(row?.kepcoTotalAmount ?? 0);
    const sum = parseFloat(row?.totalAmountSum ?? row?.householdTotalSum ?? 0);
    if (isNaN(k) || isNaN(sum)) return null;
    return k - sum;
}

function escCsv(v) {
    if (v === null || v === undefined) return "";
    const s = String(v);
    if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
}

export function buildHouseholdCsvRows(hh) {
    const lines = [LEDGER_CSV.household.join(",")];
    if (!hh?.rows?.length) return lines;
    for (const r of hh.rows) {
        lines.push(
            [
                r.regYm,
                hh.roomName,
                r.status,
                r.usageQty,
                r.individualCost,
                r.allocatedCommonCost,
                r.manualAdjustAmount,
                r.totalAmount,
            ]
                .map(escCsv)
                .join(","),
        );
    }
    return lines;
}

export function buildMatrixCsvRows(regYm, matrix, { showAreaCol = true } = {}) {
    const lines = [LEDGER_CSV.matrix.join(",")];
    if (!matrix?.rows?.length) return lines;
    for (const r of matrix.rows) {
        lines.push(
            [
                regYm,
                r.roomName,
                r.exclusiveArea,
                r.usageQty,
                r.individualCost,
                showAreaCol ? r.allocatedCommonCost : "",
                r.manualAdjustAmount,
                r.totalAmount,
            ]
                .map(escCsv)
                .join(","),
        );
    }
    return lines;
}

export function downloadCsvBlob(filename, lines) {
    const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
